import { httpClient } from '../../commons/httpClient'

export interface InfoFromCode {
  companyName: string
}

export const getInfoFromCode = (code: string): Promise<any> => {
  return httpClient.put(`/IchraDecisionTool/ProspectApplication/WelcomeInfo`, { token: code })
}
